import { Save, Search, ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface SidebarHeaderProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSaveClick: () => void;
  onToggleCollapse: () => void;
  isMinimized?: boolean;
}

export function SidebarHeader({
  searchQuery,
  onSearchChange,
  onSaveClick,
  onToggleCollapse,
  isMinimized = false,
}: SidebarHeaderProps) {
  if (isMinimized) {
    return (
      <div className="p-2 border-b">
        <Button
          variant="outline"
          size="icon"
          onClick={onSaveClick}
          className="w-full h-8 mb-2"
        >
          <Save className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleCollapse}
          className="w-full h-8"
        >
          <ChevronLeft className="h-4 w-4 rotate-180" />
        </Button>
      </div>
    );
  }

  return (
    <div className="p-4 border-b">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold tracking-tight">Saved Calculations</h2>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onSaveClick}
            className="h-8 px-3"
          >
            <Save className="h-4 w-4 mr-2" />
            Save
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggleCollapse}
            className="h-8 w-8"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search calculations..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 h-9"
        />
      </div>
    </div>
  );
}